import React from 'react';
import styled from 'styled-components';

const StyledButton = styled.button`
  background-color: ${props => props.disabled ? '#ccc' : '#006666'};
  color: #fff;
  border: none;
  border-radius: 10px;
  padding: 8px 24px;
  font-family: 'Roboto', sans-serif;
  font-size: 13px;
  cursor: ${props => props.disabled ? 'default' : 'pointer'};
  margin-left: 16px;
  transition: background 0.2s;

  &:hover {
    background-color: ${props => props.disabled ? '#ccc' : '#006666'};
  }
`;

const Botao = ({ children, ...props }) => (
  <StyledButton {...props}>{children}</StyledButton>
);

export default Botao;